import { HTTP } from './helpers/http.js'

export default {
  create(organizationId, revId, data) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/revs/${revId}/checklists`,
      data
    )
  },
  delete(organizationId, revId, checklistId) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/revs/${revId}/checklists/${checklistId}`
    )
  },
  getAll(organizationId, revId) {
    const url = `/api/v1/organizations/${organizationId}/revs/${revId}/checklists`
    return HTTP.get(url)
  },
  createResponse(organizationId, revId, checklistId, checklist) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/revs/${revId}/checklists/${checklistId}/responses`,
      checklist
    )
  },
  updateResponse(
    organizationId,
    revId,
    checklistId,
    checklistResponseId,
    checklist
  ) {
    return HTTP.patch(
      `/api/v1/organizations/${organizationId}/revs/${revId}/checklists/${checklistId}/responses/${checklistResponseId}`,
      checklist
    )
  },
}
